function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#ED1C24",
  stroke: "#ED1C24",
  d: "M11.813 11.813H5.694c-.176 0-.352.067-.486.2-.269.27-.269.704 0 .973.134.134.31.201.486.201h6.119v6.119c0 .176.067.352.2.486.27.269.704.269.973 0 .134-.134.201-.31.201-.486v-6.119h6.119c.176 0 .352-.067.486-.2.268-.27.269-.704 0-.973-.134-.134-.31-.201-.486-.201h-6.119V5.694c0-.176-.067-.352-.2-.486-.27-.269-.705-.268-.973 0-.134.134-.201.31-.201.486v6.119z"
});

var SvgAddRed = function SvgAddRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAddRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-red.ca2797b3.svg";
export { ForwardRef as ReactComponent };